module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goTop()
      }
    }
  }, [_vm._v("TOPに戻る")])])]), _c('div', {
    staticClass: "container bg02 txtC moral-complete"
  }, [_c('div', {
    staticClass: "row step-up__title-bg"
  }, [_c('div', {
    staticClass: "user-outline"
  }, [(_vm.stepUpUser.profile_image) ? _c('div', {
    staticClass: "user-outline__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.stepUpUser.profile_image_path + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  })]) : _c('div', {
    staticClass: "user-outline__img"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_profile.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "brown home__step-up__content-member-text-item"
  }, [_c('span', {
    staticClass: "fz19 brown"
  }, [_vm._v(_vm._s(_vm.stepUpUser.step_up_user_name))]), _vm._v("さんの"), _c('br'), _vm._v("評価の確認をお願いいたします。")])]), _c('div', {
    style: ('text-align: left')
  }, [_c('p', {
    staticClass: "willmust__intro__txt mt15 mb15"
  }, [_vm._v("※〜" + _vm._s(_vm.stepUpUser.end_date) + "までは、"), _c('br'), _vm._v("　何度でも"), _c('span', [_vm._v("再編集・再提出ができます。")])]), _c('button', {
    staticClass: "btn02 -stepup-modify",
    staticStyle: {
      "width": "100%",
      "height": "42px"
    },
    on: {
      "click": function($event) {
        _vm.goStepUpAnswerEdit()
      }
    }
  }, [_c('span', [_vm._v("再編集・再提出する")])])])]), _vm._l((_vm.answerContent), function(answer, i) {
    return (_vm.answerContent) ? _c('div', [_c('div', {
      staticClass: "row user-outline stepup-answered-list-bg"
    }, [_c('div', {
      staticClass: "fz16 brown stepup-question-padding"
    }, [_c('div', [_c('div', {
      staticClass: "stepup-question-number setelced-answer"
    }, [_c('span', [_vm._v(_vm._s(i + 1))])])]), _c('div', {
      staticClass: "fz14 stepup-",
      domProps: {
        "innerHTML": _vm._s(_vm.content(answer.question_content))
      }
    }), _c('div', {
      staticClass: "stepup-selected-answer"
    }, [_c('div', {
      staticClass: "stepup-selected-answer-box"
    }, [_c('span', {
      staticClass: "fz13 bold",
      domProps: {
        "innerHTML": _vm._s(_vm.selectAnswers[answer.answer_content].content)
      }
    })])])])])]) : _vm._e()
  }), _c('div', {
    staticClass: "row step-up__title-bg"
  }, [_c('p', {
    staticClass: "step-up__title-text mb10"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.stepUpUser.step_up_user_name) + "さん")]), _vm._v("の評価は"), _c('br'), _vm._v("以上でよろしいですか？")]), _c('button', {
    staticClass: "btn02 -stepup-modify",
    staticStyle: {
      "width": "100%",
      "height": "42px"
    },
    on: {
      "click": function($event) {
        _vm.goStepUpAnswerEdit()
      }
    }
  }, [_c('span', [_vm._v("再編集・再提出する")])]), _c('p', {
    staticClass: "willmust__intro__txt mt10"
  }, [_vm._v("※〜" + _vm._s(_vm.stepUpUser.end_date) + "までは、"), _c('br'), _vm._v("　何度でも"), _c('span', [_vm._v("再編集・再提出ができます。")])])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07af6200!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/step-up-answer-list.pug
// module id = 1370
// module chunks = 1